import { render, staticRenderFns } from "./financialStatistics.vue?vue&type=template&id=0566bee4&scoped=true&"
import script from "./financialStatistics.vue?vue&type=script&lang=js&"
export * from "./financialStatistics.vue?vue&type=script&lang=js&"
import style0 from "./financialStatistics.vue?vue&type=style&index=0&id=0566bee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566bee4",
  null
  
)

component.options.__file = "financialStatistics.vue"
export default component.exports